export const API_URL = '/api/';
export const LOGIN_URL = `${API_URL}login`;
export const APPOINTMENT_URL = `${API_URL}appointment`;
export const NOTIFICATION_URL = `${API_URL}pendingappointment`;
export const AVAILABLE_APPOINTMENT_URL = `${API_URL}appointment/available`;
export const APPOINTMENT_TYPE_URL = `${API_URL}appointmenttype`;
export const BUSINESS_INFO_URL = `${API_URL}business/id`;
export const CLIENT_URL = `${API_URL}client`;
export const TOKEN_URL = `${API_URL}token/jwt`;
export const RESET_PASSWORD_URL = `${API_URL}user/password`;
export const requestResetUrl = email => `${API_URL}user/email/${email}/passwordresetcode`;
export const POLL_INTERVAL = 90000;



// WEBPACK FOOTER //
// ./src/config.js